/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./settingHead.vue?vue&type=template&id=657c7527&scoped=true&"
import script from "./settingHead.vue?vue&type=script&lang=js&"
export * from "./settingHead.vue?vue&type=script&lang=js&"
import style0 from "./settingHead.vue?vue&type=style&index=0&id=657c7527&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c7527",
  null
  
)

export default component.exports